import type { RouteRecordRaw } from "vue-router";

import { getRouteParam } from "../utils";

export const paymentRoutes: RouteRecordRaw[] = [
  {
    path: "/payment/:licensePlate?/:country?/:expires?",
    name: "payment",
    component: () => import(/* webpackChunkName: "dashboard-payment" */ "../../components/payment/PaymentView.vue"),
    props: route => ({
      licensePlate: getRouteParam(route, "licensePlate"),
      country: getRouteParam(route, "country"),
      expires: getRouteParam(route, "expires")
    }),
    meta: {
      titleKey: "pageTitle.payment",
      viewGroup: "payment",
      viewGroupParams: ["licensePlate", "country", "expires"]
    }
  },
  {
    path: "/payment/status",
    name: "payment-status",
    component: () =>
      import(
        /* webpackChunkName: "dashboard-payment-status" */ "../../components/payment/PaymentTransactionStatusView.vue"
      ),
    meta: { titleKey: "pageTitle.paymentStatus", viewGroup: "payment-status" }
  }
];
